import React from "react";
import RegistrationMarketingStepper from "../../../components-user/event-management/lectures/registration/registration-steps/RegistrationMarketingStepper";
export default function RegisterMarketingLecture() {
  return <RegistrationMarketingStepper />;
}
